export default __webpack_public_path__ + "static/media/HP-Logo.7282d9bc.png";